import { useEffect, useRef, useState } from 'react';

const CHANGE_LABEL = { created: 'نت ساخته شد', updated: 'نت ویرایش شد', archived: 'نت بایگانی شد' };

export default function TeachPanel({ agent }) {
  const [draft, setDraft] = useState('');
  const logRef = useRef(null);

  useEffect(() => { agent.loadMessages(); }, [agent.loadMessages]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight;
  }, [agent.messages]);

  const send = async () => {
    const text = draft.trim();
    if (!text || agent.busy) return;
    setDraft('');
    await agent.sendMessage(text);
  };

  return (
    <div className="consultant-panel">
      <div className="teach-log" ref={logRef}>
        {agent.messages.length === 0 && (
          <div className="consultant-empty">با تایپ‌کردن، به مشاور دانش بیاموزید.</div>
        )}
        {agent.messages.map((m) => (
          <div key={m.id} className={`teach-msg ${m.role}`}>
            <div>{m.content}</div>
            {m.changes && m.changes.length > 0 && (
              <div className="teach-changes">
                {m.changes.map((c, i) => (
                  <span key={i}>{CHANGE_LABEL[c.action] || c.action}{i < m.changes.length - 1 ? ' · ' : ''}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="consultant-toolbar">
        <input
          className="consultant-input" style={{ flex: 1 }}
          value={draft} onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') send(); }}
          placeholder="به مشاور چیزی بیاموزید…" disabled={agent.busy}
        />
        <button className="consultant-btn" onClick={send} disabled={agent.busy || !draft.trim()}>
          {agent.busy ? 'در حال پردازش…' : 'ارسال'}
        </button>
      </div>
    </div>
  );
}
